export default __webpack_public_path__ + "static/media/calc-dash.6ecd6ce1.svg";